import { useCallback } from 'react';
import { confirmation, notify } from '@/components';
import { useUngroupTasksMutation } from '@/redux';
import { useTranslation } from 'react-i18next';

export function useUngroupTasksAction() {
  const { t } = useTranslation();
  const [ungroup] = useUngroupTasksMutation();

  const handleDelete = useCallback(
    (value: { groupId: string }) => {
      ungroup(value)
        .unwrap()
        .then(() => notify.success.t('tasks.groups.ungroup.success'));
    },
    [ungroup],
  );

  return useCallback(
    (groupId: string) => {
      confirmation.show({
        title: t('tasks.groups.ungroup.title'),
        body: t('tasks.groups.ungroup.confirmation'),
        onConfirm: () => handleDelete({ groupId }),
      });
    },
    [handleDelete, t],
  );
}
